'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _templateObject = _taggedTemplateLiteral(['\n  height: ', ';\n  position: absolute;\n  right: ', ';\n  width: ', ';\n\n  &::after {\n    padding: ', ';\n  }\n'], ['\n  height: ', ';\n  position: absolute;\n  right: ', ';\n  width: ', ';\n\n  &::after {\n    padding: ', ';\n  }\n']),
    _templateObject2 = _taggedTemplateLiteral(['\n  color: inherit;\n  display: block;\n  flex-grow: 1;\n'], ['\n  color: inherit;\n  display: block;\n  flex-grow: 1;\n']),
    _templateObject3 = _taggedTemplateLiteral(['\n  fill: currentColor;\n  stroke: currentColor;\n  stroke-width: 2;\n'], ['\n  fill: currentColor;\n  stroke: currentColor;\n  stroke-width: 2;\n']);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactUtils = require('react-utils');

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _Translatable = require('../decorators/Translatable');

var _Translatable2 = _interopRequireDefault(_Translatable);

var _Style = require('../core/Style');

var _sizes = require('HubStyleTokens/sizes');

var _tshirtSize = require('../utils/propTypes/tshirtSize');

var TShirtSize = _interopRequireWildcard(_tshirtSize);

var _UIDialogButton = require('../dialog/UIDialogButton');

var _UIDialogButton2 = _interopRequireDefault(_UIDialogButton);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var SIZE_OPTIONS = {
  small: {
    size: _sizes.SMALL_CLOSE_BUTTON_SIZE,
    padding: 12
  },
  medium: {
    size: _sizes.MEDIUM_CLOSE_BUTTON_SIZE,
    padding: 16
  },
  large: {
    size: _sizes.MODAL_CLOSE_BUTTON_SIZE,
    padding: 20
  },
  'extra-large': {
    size: _sizes.EXTRA_LARGE_CLOSE_BUTTON_SIZE,
    padding: 38
  }
};

var CloseButton = (0, _styledComponents2.default)(_UIDialogButton2.default).withConfig({
  displayName: 'UICloseButton__CloseButton'
})(_templateObject, function (props) {
  return (0, _Style.remCalc)(SIZE_OPTIONS[props.size]['size']);
}, (0, _Style.remCalc)(_sizes.MODAL_CLOSE_BUTTON_OFFSET), function (props) {
  return (0, _Style.remCalc)(SIZE_OPTIONS[props.size]['size']);
}, function (props) {
  return (0, _Style.remCalc)(SIZE_OPTIONS[props.size]['padding']);
});

var CloseIcon = _styledComponents2.default.svg.withConfig({
  displayName: 'UICloseButton__CloseIcon'
})(_templateObject2);

var CloseIconInner = _styledComponents2.default.path.withConfig({
  displayName: 'UICloseButton__CloseIconInner'
})(_templateObject3);

var UICloseButton = _react2.default.createClass({
  displayName: 'UICloseButton',

  propTypes: {
    className: _react.PropTypes.string,
    color: _react.PropTypes.string,
    disabled: _react.PropTypes.bool.isRequired,
    I18n: _react.PropTypes.object,
    onClick: _react.PropTypes.func.isRequired,
    size: TShirtSize.propTypeForSizes(['sm', 'md', 'lg', 'xl']),
    style: _react.PropTypes.object
  },

  getDefaultProps: function getDefaultProps() {
    return {
      disabled: false,
      size: 'large'
    };
  },
  renderCloseIcon: function renderCloseIcon() {
    return _react2.default.createElement(
      CloseIcon,
      { viewBox: '0 0 14 14', xmlns: 'http://www.w3.org/2000/svg' },
      _react2.default.createElement(CloseIconInner, {
        d: 'M14.5,1.5l-13,13m0-13,13,13',
        transform: 'translate(-1 -1)'
      })
    );
  },
  render: function render() {
    var _props = this.props,
        className = _props.className,
        color = _props.color,
        disabled = _props.disabled,
        I18n = _props.I18n,
        onClick = _props.onClick,
        size = _props.size,
        style = _props.style,
        rest = _objectWithoutProperties(_props, ['className', 'color', 'disabled', 'I18n', 'onClick', 'size', 'style']);

    var computedSize = TShirtSize.fromProp(size).long;

    return _react2.default.createElement(CloseButton, _extends({}, rest, {
      'aria-label': I18n.text('salesUI.UICloseButton.label'),
      className: (0, _reactUtils.classNames)('private-close__button', className, {
        'private-close__button--disabled': disabled
      }),
      'data-action': 'close',
      disabled: disabled,
      IconHolder: this.renderCloseIcon,
      onClick: onClick,
      size: computedSize,
      style: _extends({
        color: color
      }, style)
    }));
  }
});

exports.default = (0, _Translatable2.default)(UICloseButton);
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.1282/js/button/UICloseButton.js
// module id = 149
// module chunks = 0